// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 443 ? "about" : chunkId) + "-legacy." + {"385":"724113db","443":"219c726e","875":"610dfb2f"}[chunkId] + ".js";
};